export const BASE_URL = (url) => {
  let URL = `https://momo4business.mtn.ci/momo4school-api/${url}`;
  // let URL = `http://192.168.1.3:8081/momo4schoolapi/${url}`;
  
  return URL;
};

// madoussou@gmail.com
// mdp123
